"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _SortableColumns = _interopRequireWildcard(require("./SortableColumns"));

var _header = require("./header");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SORT_DIRECTION = _header.Header.SORT_DIRECTION;

var Head =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Head, _React$PureComponent);

  function Head() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Head);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Head)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "processHeaders", function (sorting, _onSortDirectionChange) {
      return function (header, headerIndex) {
        var _header$props = header.props,
            sortable = _header$props.sortable,
            sortSequence = _header$props.sortSequence,
            defaultSortDirection = _header$props.defaultSortDirection;
        if (!sortable) return header;
        return _react.default.cloneElement(header, {
          defaultSortDirection: sortSequence[0] || defaultSortDirection,
          onSortDirectionChange: function onSortDirectionChange() {
            _onSortDirectionChange(headerIndex);
          },
          sortable: true,
          currentIndex: sorting[headerIndex].currentIndex,
          sortingDirection: sorting[headerIndex].sortingDirection,
          sortSequence: sortSequence || Object.values(SORT_DIRECTION)
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "processRows", function (children, sorting, onSortDirectionChange) {
      return _react.default.Children.map(children, function (row) {
        return _react.default.cloneElement(row, {
          children: _react.default.Children.map(row.props.children, _this.processHeaders(sorting, onSortDirectionChange))
        });
      });
    });

    return _this;
  }

  _createClass(Head, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var children = this.props.children;

      var _getHeadersInfo = (0, _SortableColumns.getHeadersInfo)(children),
          headers = _getHeadersInfo.headers,
          hasSortableHeaders = _getHeadersInfo.hasSortableHeaders;

      if (hasSortableHeaders) {
        return _react.default.createElement(_SortableColumns.default, {
          headers: headers
        }, function (_ref) {
          var sorting = _ref.sorting,
              updateSortDirectionByIndex = _ref.updateSortDirectionByIndex;
          return _react.default.createElement("thead", {
            className: "co-table__head"
          }, _this2.processRows(children, sorting, updateSortDirectionByIndex));
        });
      }

      return _react.default.createElement("thead", {
        className: "co-table__head"
      }, children);
    }
  }]);

  return Head;
}(_react.default.PureComponent);

Head.displayName = 'Table.Head';
Head.propTypes = {
  /** {---} Sequence of: @@<Table.Row>@@ (required, min: 1) */
  children: _propTypes.any.isRequired
};
var _default = Head;
exports.default = _default;
Head.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "processHeaders",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "sorting",
      "type": null
    }, {
      "name": "onSortDirectionChange",
      "type": null
    }],
    "returns": null
  }, {
    "name": "processRows",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "children",
      "type": null
    }, {
      "name": "sorting",
      "type": null
    }, {
      "name": "onSortDirectionChange",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "Table.Head",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "{---} Sequence of: @@<Table.Row>@@ (required, min: 1)"
    }
  }
};